const state = {
    darkModeEnabled: false,
    roadsAboveLayer: false,
    isMapDark: false,
    rawDataEnabled: true,
}

const mutations = {
    setSetting(state, data) {
        state[data.id] = data.value
    },
    clearSettings(state) {
        state = null
    }
}

const getters = {

    getAllSettings: state => {
        return state
    }

}

export default {
    state,
    mutations,
    getters
}
